import _ from 'lodash';
import Promise from 'bluebird';
import {
    generateResourceStore,
    generateResourceGetters,
    generateResourceActions,
    generateResourceMutations,
} from '../generators';

// actions
const createActions = (helpers) => ({
    ...generateResourceActions(helpers),

    getInitialData({ commit }, url) {
        const path = helpers.uriFormat(url);
        commit('setPath', path);
        commit('processing');

        return helpers.api.getData(path)
            .then(res => {
                commit('setContent', res);
                return res;
            })
            .finally(() => commit('idle'))
    }
})

export default (helpers) => {
    if (_.isFunction(helpers)) {
        helpers = helpers();
    }

    return {
        namespaced: true,
        state: generateResourceStore(helpers),
        getters: generateResourceGetters(helpers),
        mutations: generateResourceMutations(helpers),
        actions: createActions(helpers),
    }
}



// WEBPACK FOOTER //
// ./seventytwo/72cms-ui/src/store/modules/base.js